// src/stores/gameStore.js
import {create} from 'zustand';

// Define initial state
const initialState = {
    gameState: 'ready', // Possible states: 'ready', 'playing', 'ended'
    startTime: null,    // Timestamp when the game starts
    endTime: null,      // Timestamp when the game ends
    score: 0,           // Example: if you want to track score
    // Add any other game-specific state here (e.g., targetsHit, ammo, etc.)
};

export const useGameStore = create((set, get) => ({
    ...initialState,

    // --- Actions to modify game state ---

    startGame: () => {
        // Only start if currently ready or ended (to allow restarting)
        // console.log('current game state :', get().gameState)
        if (get().gameState === 'ready' || get().gameState === 'ended') {
            console.log("GameStore: Starting game...");
            set({
                gameState: 'playing',
                startTime: Date.now(), // Record start time
                endTime: null,         // Reset end time
                score: 0,              // Reset score
                // Reset other game-specific states here if needed
            });
            console.log("gameState after StartGame:", get().gameState);
        } else {
            console.warn("GameStore: Game is already playing or in an unexpected state.");
        }
    },

    endGame: () => {
        // Only end if currently playing
        if (get().gameState === 'playing') {
            console.log("GameStore: Ending game...");
            const finalTime = Date.now();
            set({
                gameState: 'ended',
                endTime: finalTime,
            });
            // You can calculate and log the duration here or in a component
            const duration = (finalTime - get().startTime) / 1000; // in seconds
            console.log(`GameStore: Game lasted ${duration.toFixed(2)} seconds. Final Score: ${get().score}`);
        } else {
            console.warn("GameStore: Game is not currently playing.");
        }
    },

    resetGame: () => {
        console.log("GameStore: Resetting game to ready state...");
        set(initialState); // Reset to the initial defined state
    },

    // Example action for the game itself
    incrementScore: (points = 1) => {
        if (get().gameState === 'playing') {
            set((state) => ({score: state.score + points}));
        }
    },

    // You might add actions like:
    // pauseGame: () => set({ gameState: 'paused' }), // If you need a pause state
    // resumeGame: () => set({ gameState: 'playing' }),
}));

// --- Optional: Selectors for derived data ---
// These can be defined outside or as part of the store if you prefer
export const selectGameDuration = (state) => {
    if (state.startTime && state.endTime) {
        return (state.endTime - state.startTime) / 1000; // in seconds
    }
    return 0;
};

export const selectIsGamePlaying = (state) => state.gameState === 'playing';
export const selectIsGameReady = (state) => state.gameState === 'ready';
export const selectIsGameEnded = (state) => state.gameState === 'ended';